import { MatchVisibility } from '../../Match.types'

export const visibilityTypeTranslation = {
  [MatchVisibility.PRIVATE]: 'match-visibility-badge-private',
  [MatchVisibility.PUBLIC]: 'match-visibility-badge-public',
} as const
